<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
			@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close>
			<template #default>
				<el-select size="small" v-model="form.type" placeholder="请选择类型">
					<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
			</template>
			<template #footer>
				<vxe-button status="danger" content="删除" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>


</style>
<script>
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	export default {
		mixins: [modalMixins],
		props: {

		},
		data() {
			return {
				modal_width: 500,
				modal_height: 300,
				modal_title: '批量删除',
				options: [],
				form:{
					type:'',
					file:[]
				}
			}
		},
		created() {
			this.getOptions()
		},
		mounted() {
			
		},
		watch: {

		},
		computed: {

		},

		methods: {
			getOptions(){
				let options = []
				let getEmun = window.systemMethods.getEmun('goodsfile')
				getEmun.forEach((item)=>{
					options.push({
						value:item.label,
						label:item.label
					})
				})
				this.options = options
				console.log(options)
			},
			modal_init() {
				this.form = {
					type:'',
					file:[]
				}
			},
			modal_hide() {
				this.form = {
					type:'',
					file:[]
				}
				this.$emit('modalhide')
			},
			submit() {
				if(!this.form.type){
					this.$message.error('请完善信息')
				}else{
					this.$confirm('该操作会删除所选类型下所有文件，是否确认操作').then(()=>{
						this.$emit('submit',this.form)
						this.modal_cancel()
					})
				}
			}
		},
		components: {
			
		}
	}
</script>